export default __webpack_public_path__ + "static/media/activity-4.bacce363.png";